import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const ClubService = {}


ClubService.getClub = function (params) {
	 let {page, searchClub} = params;
	 let offset = (page-1)*10;
	 
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-club',
		method: 'get',
        params: {
            'offset' : offset,
			searchClub
        }
	})
}; 

ClubService.createClub = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/create-club`,
		method: 'post',
        data: data

	})
};

ClubService.getClubWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-club/${id}`,
		method: 'get',

	})
};

ClubService.updateClub = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/edit-club`,
		method: 'post',
        data: data
	})
};

ClubService.deleteClub = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/delete-club`,
		method: 'post',
        data: data
	})
};



export default ClubService;